import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { C3DataUploadTable } from "./table";
import { C3DataUploadEdit } from "./edit";

export default function C3DataUpload() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Chargement de fichiers");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<C3DataUploadEdit />} />
      <Route index element={<C3DataUploadTable />} />
    </Routes>
  );
}
